import React from 'react'

const About = () => {
  return (
    <div name="about" className='w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white'>
      <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
            <h3 className='text-4xl font-bold inline border-b-4 border-gray-500'>About Me</h3>

        </div>

        <p className='text-xl mt-20'>I am React.js Developer. I also have good hands on website development. I'm new in this portal but I'll give you quality work to my clients. I worked for so many clients with positive feedback's and have good relations with them. I would love to help you with the following technologies.</p>
        
      
      </div>
    </div>
  )
}

export default About
